function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.753,7.4395 L9.753,0.3525 C9.355,-0.1175 8.646,-0.1175 8.247,0.3525 L0.247,7.4395 C0.088,7.6275 0,7.8705 0,8.1205 L0,19.4835 C0,19.7685 0.224,20.0005 0.5,20.0005 L6.5,20.0005 C6.776,20.0005 7,19.7685 7,19.4835 L7,16.0095 C7,13.0005 11,13.0005 11,15.8995 L11,19.4835 C11,19.7685 11.224,20.0005 11.5,20.0005 L17.5,20.0005 C17.776,20.0005 18,19.7685 18,19.4835 L18,8.1205 C18,7.8705 17.912,7.6275 17.753,7.4395",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-1 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/home.6f49f4a1.svg";
export { SvgComponent as ReactComponent };